<template>
  <div class="sms">
    <Header propsTitle="SMS 인증" @clickBack="$emit('clickBack')" />
    <div class="container">
      <div class="page-inner">
        <!-- 단계 표시 UI -->
        <Stepper step="2" />
        <v-form ref="form">
          <h1 class="step-title">SMS 인증</h1>

          <SmsInput
            ref="refSmsInput"
            :userData="userData"
            @clickSendCode="clickSendCode"
          />

          <!-- 인증번호 받기 버튼 클릭 시 노출 -->
          <CodeInput
            ref="refCodeInput"
            :userData="userData"
            :reqData="reqData"
            @completeCertify="completeCertify"
            @gotoSmsInput="gotoSmsInput"
            @resend="clickResend"
          />
        </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import Header from "./common/Header.vue";
import Stepper from "./agree/Stepper.vue";
import SmsInput from "./smsForm/SmsInput.vue";
import CodeInput from "./smsForm/CodeInput.vue";

const rulesService = require("@/utils/rules.js");

export default {
  components: {
    Header,
    Stepper,
    SmsInput,
    CodeInput,
  },
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      cellRules: rulesService.cellRules(),
      isSend: false,
      reqData: {
        endpoint: "sendCertifySms",
        smsSendMode: "regist", // 회원가입 인지 ? 비밀번호 찾기 모드인지?
        userCell: "",
        inputCode: "",
        code: "",
        isTest: "N", // sms test로 할때 Y
      },
    };
  },
  methods: {
    clickResend() {
      this.reqData.inputCode = "";
      this.clickSendCode("resend");
    },
    clickSendCode(opt) {
      if (!this.$refs.form.validate()) {
        this.$refs.refSmsInput.$refs.refCell.focus();
        return;
      }

      // 필수
      const $h = this.$helper;
      const DT = this.userData;
      const RF = this.$refs;

      let msg = `휴대폰번호를 입력해주세요`;
      if (!$h.requiredCheck(DT.cell, RF.refCell, msg)) return;

      if (DT.cell.length < 10) return;

      this.isSend = false;
      this.userData.checkSms = false;
      this.reqData.userCell = this.userData.cell;
      this.reqData.code = this.$helper.randomNumber(1000, 9999);
      this.saveDataPreLoginQuery(this.reqData).then((res) => {
        if (res === undefined) return;
        console.log("res", res);
        if (res.resultCode > 0) {
          let msg = `회원가입된 아이디(휴대폰번호)입니다.`;
          // $h.showTostMessage("", msg, "info");
          this.$emit("duplicated");
          return;
        }
        console.log("userData", this.userData);

        this.isSend = true;
        this.userData.checkSms = true;
        setTimeout(() => {
          this.$refs.refCodeInput.$refs.refCode.focus();
        }, 1000);

        if (opt === "resend") return;
        this.$refs.refCodeInput.startTimer(this.isSend);
      });
    },
    completeCertify() {
      console.log("", this.reqData);
      this.userData.checkedSms = false;
      const $h = this.$helper;
      const DT = this.reqData;
      const RF = this.$refs;
      let msg = `인증번호를 입력해주세요.`;
      if (!$h.requiredCheck(DT.inputCode, RF.refCodeInput.$refs.refCode, msg))
        return;

      if (Number(this.reqData.inputCode) !== Number(this.reqData.code)) {
        msg = `전달받은 인증번호를 확인해 주세요.`;
        $h.showTostMessage("", msg, "info");
        this.$refs.refCodeInput.$refs.refCode.focus();
        return;
      }

      this.userData.checkedSms = true;
      this.userData.loginId = this.userData.cell;

      // timer종료 처리
      this.$refs.refCodeInput._reSetTimer();
      this.$emit("clickNextEmit", "profile");
    },
    gotoSmsInput() {
      this.isSend = false;
      this.userData.checkSms = false;
    },
    changeCell() {
      // 로그인시 -> 회원정보 수정시 작동
      if (!this.isAuthorized) return;
      // this.userData.checkSms = true;
      // if (this.me.originCell !== this.userData.cell) {
      //     this.userData.checkSms = false;
      // }
      // console.log("changeCell", this.userData.cell, this.me);
    },
    ...mapActions(["saveDataPreLoginQuery"]),
  },
  computed: {
    ...mapGetters(["isAuthorized"]),
    ...mapState(["me"]),
  },
};
</script>
<style lang="scss">
.sms {
  .timer {
    text-align: center;
    color: $primary-color;
    margin-bottom: 10px;
  }

  .step-sub-title {
    b {
      color: $primary-color;
    }
  }

  .link-group {
    margin: 0 0;
    text-align: right;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .v-label {
      font-size: 14px;
      margin-left: 10px;
    }

    .v-btn {
      font-weight: 700;
      background-color: $mid-green;
      color: #ffffff;
      font-size: 12px;
      height: 28px;
    }
  }
}
</style>